'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _affiliates = require('./affiliates.component');

var _affiliates2 = _interopRequireDefault(_affiliates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var affiliatesModule = _angular2.default.module('app.containers.affiliates', [_angularUiRouter2.default]).config(function ($stateProvider) {
  "ngInject";

  $stateProvider.state('affiliates', {
    url: '/affiliates',
    template: '<affiliates></affiliates>'
  });
}).component('affiliates', _affiliates2.default);

exports.default = affiliatesModule;


/** WEBPACK FOOTER **
 ** ./client/app/containers/affiliates/affiliates.js
 **/